<template>
  <div class="hellos">
    <div class="headers">
      <img style="" src="../assets/logo.png" alt="" />
      <p>创新与知识产权管理人才服务系统</p>
    </div>
    <div
      style="width: 100%"
      :height="bannerHeight + 'px'"
      class="header"
      v-if="ulshow"
    >
      <h3>通知公告</h3>
      <h3>Qualification inquiry</h3>
    </div>
    <div class="center">
      <div class="Newsconsultation">
        <div class="tab">
          <!-- <p
            class="fh"
            style="color: #000; text-align: left"
            
          >
            通知公告 &nbsp;<span style="color:#2791e7;cursor: pointer;" v-show="ret_fn" @click="return_fn()"><i class="el-icon-arrow-right"></i> 返回</span>
          </p> -->
        </div>
        <div
          v-show="zwsjulshow"
          style="
            height: 313px;
            display: flex;
            font-size: 15px;
            justify-content: center;
            align-items: center;
          "
        >
          <!-- <p style="font-size: 20px">暂无数据</p> -->
          <el-empty :image-size="200" description="暂无公告"></el-empty>
        </div>
        <!-- <div style="min-height: 200px" v-if="ulshow">
          <ul
            v-cloak
            class="ul"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <li @click="details(item.id)" style="cursor: pointer">
              <dl>
                <dd>
                  <p class="p_first">
                    <span
                      v-text="item.notice_title"
                      @click="details(item.id)"
                      :title="item.notice_title"
                      style="color: #000; font-weight: normal"
                      >{{ item.notice_title }}</span
                    >
                    <img
                      style="padding-left: 5px"
                      :src="item.notice_pic_path"
                      alt=""
                    />
                    <span
                      class="times"
                      style="color: #000"
                      :title="item.pub_time"
                    >
                      {{ item.pub_time.slice(0, 10) }}</span
                    >
                  </p>
                </dd>
              </dl>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- <div class="pagination" v-show="ulshow">
        <div style="width: 100%; height: 100px"> -->
      <!-- 分页区域 -->
      <!-- <el-pagination
            v-cloak
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :pager-count="5"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div> -->

      <div  class="details">
        <!-- <i class=""></i> -->
        <!-- <img
          class="fh"
          @click="return_fn()"
          style="
            height: 15px;
            width: 15px;
            left: 15px;
            top: 8px;
            position: absolute;
          "
          src="../image/iframe/fh.png"
          alt=""
        /> -->
        <div
          class="details_div"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255)"
        >
          <h2 class="p_title" :title="s_title">
            {{ s_title }}
          </h2>
          <p style="color: #999; line-height: 30px;font-size: 14px;">
            <i class="el-icon-time" style="margin-right: 7px"></i>
            {{ pub_time }}
          </p>
          <div
            style="
              float: left;
              white-space: pre-wrap;
              overflow: auto;
            "
            class="p_content"
            v-html="s_conter"
          ></div>
        </div>
      </div>
      <!-- <div v-show="ret_fn" style="height: 120px"></div> -->
    </div>
    <!-- <Foot class="foot" /> -->
  </div>
</template>
  
  <script>
import Foot from "./Foot.vue";
import {
  getqueryPageInfo,
  getHomeNoticeList,
  getDeleteNotice,
  getDeployNotice,
  getRevoke,
  getDetailById,
} from "@/api/api.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import { mapState } from "vuex";
export default {
  components: { Foot },
  computed: {
    ...mapState(["screenHeight"]),
  },

  data() {
    return {
      loading: false,

      s_title: "",
      s_conter: "",
      pub_time: "",
      ret_fn: false,
      ulshow: true,
      tableData: [],
      zwsjulshow: false,
      currentPage: 1, //当前页
      pageSize: 10, //当前页容量
      total: null, //总数
    };
  },

  created() {
    this.loading = true;
    let id = ""
    if (this.$route.query.id) {
      id = this.$route.query.id
      this.loading = false
    } else {
      id = sessionStorage.getItem('id')
      this.loading = false
    }
      this.details(id);
      

    this.bannerHeight = (730 / 2560) * document.body.clientWidth;
  },
  mounted() {
    // console.log(/(ipad|iphone|ipod|windows phone|android)/i.test(navigator.userAgent),window.innerWidth)
    const that = this;
    window.onresize = () => {
      return (() => {
        that.bannerHeight = (730 / 2560) * document.body.clientWidth;
      })();
    };
    let id = ""
    if (this.$route.query.id) {
      id = this.$route.query.id
      // this.loading = false
    } else {
      id = sessionStorage.getItem('id')
      // this.loading = false
    }
    if (
      /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
      typeof window.orientation !== "undefined"
    ) {
      this.$router.push({name:"phoneRotation",query: { id: id }});
    } else {
      this.$router.push({ name: "index" , query: { id: this.$route.query.id }});
    }
    // console.log(typeof window.orientation)
    // that.setSize();
  },

  methods: {
    return_fn() {
      this.ulshow = true;
      this.ret_fn = false;
    },
    details(item) {
      sessionStorage.setItem('id',item)
      this.loading = true;
      window.scrollTo(0, 0);
      getDetailById(`${item}&type=Y`).then((res) => {
        if (res.code == 1000) {
          this.s_title = res.data.notice_title;
          this.s_conter = res.data.notice_content;
          this.pub_time = res.data.pub_time.slice(0, 10);
          document.getElementById("app").scrollTop = 0;

          this.loading = false;
        }
      });
    },

  

    handleSizeChange(val) {
      console.log("每页：${val}条");
      this.pageSize = val;
    },
    //分页 -- 当前页数
    handleCurrentChange(val) {
      console.log("当前：页${val}条");
      this.currentPage = val;
    },
  },
};
</script>
  
  
  <style scoped lang="less">
.hellos {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
::v-deep span {
  font-size: 10px !important;
}
::v-deep table {
  max-width: 100% !important;
}
@media screen and (max-width: 1000px) {
  .hellos {
    font-size: 12px;
  }
  ::v-deep span {
    font-size: 10px;
  }
}
@media screen and (max-width: 700px) {
  body {
    font-size: 7px;
  }
  ::v-deep span {
    font-size: 10px;
  }
}
@media screen and (max-width: 600px) {
  body {
    font-size: 6px;
  }
  ::v-deep span {
    font-size: 10px;
  }
}
::v-deep img {
  max-width: 100% !important;
}
.p_title {
  line-height: 35px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  white-space: pre-wrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
}
.headers {
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  // background: #409eff;
  // color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f0f0;
  img{
    width: 50px;
    height: 40px;
    margin-right: 20px;
  }
}
.header {
  // padding-top: 140px;
  box-sizing: border-box;
  height: 160px;
  font-size: 20px;
  text-align: left;
  background: url("../assets/notice.png") 100% 100% no-repeat;
  background-size: 100% 100%;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    width: 80%;
    margin: 0 auto;
    line-height: 40px;
    // margin-bottom: 30px;
    font-weight: normal;
  }
  :last-child {
    font: lighter 20px/40px PMingLiU;
    color: #969494;
    // font-style: SourceHanSansCN-Light;
  }
}

.p_content {
  line-height: 30px;
  width: 100%;
  word-wrap: break-word;
  color: #000;
  margin-bottom: 20px;
  font-size: 12px;
  text-align: left;
  // padding: 0 10px;
  ::v-deep span {
    font-size: 12px;
  }
  ::v-deep p {
    font-size: 12px;
  }
  .ql-align-justify {
    font-size: 12px;
  }
  img {
    width: 100% !important;
  }
  ::v-deep table {
    max-width: 100%;
  }
  p {
    font-size: 12px;
    word-wrap: break-word;
    width: 90%;
    white-space: initial;
    text-overflow: ellipsis;
    overflow: hidden;
    // max-width: 250px;
    text-align: left;
  }
}

// .hellos {
//   width: 100%;
//   height: 100%;
//   background: #fff !important;

//   // position: relative;
// }

.details {
  width: 100%;
  margin-top: 26px;
  display: flex;
  min-height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  background: #fff;
  justify-content: center;
  position: relative;
  // align-items: center;
  // padding: 30px;

  .details_div {
    // background: rgb(249, 249, 249);
    width: 100%;
    min-height: 205px;

    margin-left: 0;
    display: flex;
    font-size: 18px;
    flex-direction: column;
    align-items: center;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  margin: auto;
  text-align: center;
  background: #fff;
}

.times {
  display: inline-block;
  height: 30px;
  // width: 150px;
  display: flex;
  padding-right: 10px;
  justify-content: center;
  align-items: center;
  color: #666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // background: url(../image/iframe/times.png) no-repeat left;
}

.p_lod {
  width: 90%;
  margin: auto;
}

.Newsconsultation_nes {
  // background: #fff;
  height: 100%;

  p {
    // margin-top: 30px;
    line-height: 30px;
  }
}

.p_first {
  height: 50px;
  display: flex;

  align-items: center;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;

  :nth-child(1) {
    font-weight: bold;
    // font-size: 20px;
    width: 70%;
    display: inline-block;
    color: #666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.ul {
  width: 100%;
  // background: rgb(255, 255, 255);
  border-radius: 3px;
  margin: 5px 0;
  // height: 100%;

  li:hover {
    // box-shadow: 0px 0px 5px rgb(0, 150, 255); /* 边框阴影 */
    // -moz-box-shadow: 0px 0px 5px #888888; /* 老的 Firefox */
    border-radius: 3px;
  }

  li {
    width: 100%;
    // margin-top: 20px;
    // margin-block: 10px;
    position: relative;
    border-bottom: 1px dashed #c7c6c6;
    // box-shadow:2px 3px 10px 2px rgba(0,0,0,0.1);
    //       transition-duration:0.1s;
    //             transition-timing-function:linear;
    //             transition-delay:0s;
    //             transition-property:all;

    dl {
      display: flex;
      justify-content: space-between;

      align-items: flex-start;
      // height: 130px;

      dd {
        width: 100%;
        display: flex;
        flex-direction: column;
        p:nth-child(2) {
          padding-left: 10px;
          padding-right: 120px;

          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /*超出3行部分显示省略号，去掉该属性 显示全部*/
          -webkit-box-orient: vertical;
        }

        p:nth-child(2) {
          position: relative;
          line-height: 30px;
          max-height: 60px;
          overflow: hidden;
          font-size: 18px;
        }

        p:nth-child(2)::after {
          position: absolute;
          bottom: 0;
          right: 0;
          padding-left: 40px;

          background: -webkit-linear-gradient(left, transparent, #fff 55%);

          background: -o-linear-gradient(right, transparent, #fff 55%);

          background: -moz-linear-gradient(right, transparent, #fff 55%);

          background: linear-gradient(to right, transparent, #fff 55%);
        }

        p {
          // display: contents;
          line-height: 30px;
          color: #999999;
        }

        div {
          // float: left;
          height: 36px;
          // margin-left: 20px;
          width: 110px;
          // font-size: 0.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          // background: rgb(0, 155, 255);
          color: rgb(255, 255, 255);
        }
      }

      dt {
        height: 100%;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.Newsconsultation {
  width: 95%;
  margin: auto;
  // background: rgb(246, 246, 246);

  .tab {
    display: flex;
    // height: 80px;
    // padding-left: 20px;
    // background: rgb(246, 246, 246);
    // padding: 10px 0 28px 0;
    align-items: center;
    //   margin-top: 15px;
    // border-bottom: 1px solid #b4b2b2;

    div {
      display: flex;
    }

    h2 {
      // margin-left: 10px;
    }

    .fh {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
    }

    .bac {
      width: 8px;
      height: 25px;
      background: rgb(242, 242, 242);
    }
  }
}

// .details {

// }

/deep/ li.active {
  background: #409eff !important;
  color: #fff;
  border-radius: 50%;
}

/* 分页
   */
/* 上一页的css  */
.pagination /deep/.btn-prev {
  max-width: 100px !important;
  height: 48px !important;

  border-radius: 2px;
  margin: 0%;
  padding: 0px;
  background: #f0f0f0;
  color: #255676 !important;
  font-weight: 600;
  margin-right: 10px !important;
}

/* 下一页的css  */
.pagination /deep/.btn-next {
  background: #f0f0f0;
  max-width: 100px !important;
  height: 48px !important;

  border-radius: 2px;
  margin: 0%;
  padding: 0px;

  margin-left: 10px !important;
}

/* 中间页数的css  */
.pagination /deep/.el-pager li {
  width: 48px;
  height: 48px;
  // background: rgb(246, 246, 246);
  font-size: 18px;
}

/* 页码数字 */
.pagination /deep/.number {
  width: 48px !important;
  height: 48px !important;

  line-height: 48px !important;
}

/* 当前页的 提示  */
.pagination /deep/.el-pager li.active {
  color: white;
}

/*  总条数的 样式css   */
.pagination /deep/.el-pagination__total {
  /* background-color: #050F23; */
  /* width: 48px !important; */
  height: 48px !important;
  text-align: center;
  /* border: 1px solid #64DEFB; */
  font-size: 18px !important;
  margin-top: 10px;
  margin-left: 10px;
}

/* 每页的 展示条数 的 css   */
.el-pagination__sizes > input {
  background-color: #081243;
  width: 100px !important;
  height: 48px !important;
}

.el-pagination .el-select .el-input .el-input__inner {
  background-color: #081243;
  width: 100px !important;
  height: 48px !important;
}
.pagination/deep/ .el-icon-more {
  margin-top: 10px !important;
}

.pagination/deep/ .el-icon-d-arrow-left {
  margin-top: 10px !important;
}

.pagination/deep/ .el-icon-d-arrow-right {
  margin-top: 10px !important;
}

/* 前往的 css  */
.el-pagination__jump {
  font-size: 20px !important;
  margin-left: 10px !important;
  /* margin-right: 10px !important; */
}

/* 前往的 页码 css   */
.el-pagination__editor.el-input > input {
  background-color: #081243;
  width: 100px !important;
  height: 48px !important;
  margin-left: 10px !important;
}

.center {
  background: #fff;
  width: 100%;
  height: 100%;
  margin: 0;
  flex: 1;
  // position: relative;
}

.foot {
  // position: absolute;
  bottom: 0;
}

// 在填充数据之前隐藏
[v-cloak] {
  display: none;
}

//上一页和下一页的样式
</style>